import { BaseSubscription } from './base_subscription';
import { CRDT } from '../crdt/crdt';
export class LiveObjSubscription extends BaseSubscription {
    constructor(connectionID, channelConfig, websocketHandler, process = "subscribe") {
        var _a;
        super(connectionID, channelConfig, websocketHandler, process);
        this.crdt = new CRDT((_a = channelConfig.snapshot) !== null && _a !== void 0 ? _a : { index: {} }, this.execute_server_merge.bind(this));
        this.crdt.setReplicaId(`r-${Math.random().toString(36).slice(2, 10)}`);
    }
    state() {
        return this.crdt.state();
    }
    async flush() {
        await this.crdt.flush();
    }
    //old
    query(path) {
        return this.crdt.query(path);
    }
    // public update() {
    //     return this.crdt.update();
    // }
    execute_server_merge(ops) {
        this.push("merge", ops);
    }
    /**
     * Here we handle the incoming snapshot update based on path delta
     * @param event
     * @param data
     * @returns Promise<void>
     */
    async handleMessage(event, data) {
        var _a, _b, _c;
        const { return_flag } = data;
        if (return_flag == "SA") {
            return;
        }
        if (event === 'art_presence') {
            const content = JSON.parse(data.data);
            this.emit('art_presence', content);
        }
        else {
            let content = [];
            content = JSON.parse(data['data']);
            if (data.event === "update") {
                // Echo suppression: if all ops are mine, skip merging
                const myId = (_c = (_b = (_a = this.crdt).getReplicaId) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : "client";
                const allMine = content.length > 0 && content.every((op) => {
                    return op.replicaId === myId;
                    // note: 'remove' has no entry; if you need to suppress those too,
                    // add a small sent-op fingerprint cache instead of relying on meta
                });
                if (!allMine) {
                    this.crdt.merge(content);
                }
            }
        }
    }
}
